import React from 'react';

class GlobalErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error("🔴 Uncaught error in App:", error, errorInfo);
        this.setState({ errorInfo });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    padding: '2rem',
                    color: '#e2c89c',
                    textAlign: 'center',
                    background: '#0a0a0a',
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontFamily: 'sans-serif'
                }}>
                    <h1 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Something went wrong</h1>
                    <p style={{ maxWidth: '600px', margin: '0 auto 2rem', lineHeight: '1.6', opacity: 0.8 }}>
                        The application encountered an unexpected error.
                    </p>
                    <div style={{
                        background: '#1a1612',
                        padding: '1rem',
                        borderRadius: '8px',
                        border: '1px solid #e5c97b44',
                        marginBottom: '2rem',
                        textAlign: 'left',
                        maxWidth: '800px',
                        width: '100%',
                        overflow: 'auto',
                        color: '#ff6b6b'
                    }}>
                        <code style={{ whiteSpace: 'pre-wrap' }}>
                            {this.state.error?.toString()}
                        </code>
                        {this.state.errorInfo && (
                            <pre style={{ marginTop: '1rem', fontSize: '0.8rem', opacity: 0.7 }}>
                                {this.state.errorInfo.componentStack}
                            </pre>
                        )}
                    </div>
                    <button
                        onClick={() => window.location.href = '/'}
                        style={{
                            padding: '12px 24px',
                            background: '#bfa97a',
                            color: '#18120b',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '1rem',
                            fontWeight: 'bold'
                        }}
                    >
                        Return to Home
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default GlobalErrorBoundary;
